<template>
  <router-link to='/'>
    <img :src="logoImage" alt="Asahi Logo" class="asahi-logo" v-bind="args"/>
  </router-link>
</template>

<script>
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'AsahiLogoNew',
  props: {
    logoImage: {
      type: String,
      required: true,
      default: '/logov2.png'
    }
  },
  data: () => ({

  })
})
</script>
<style lang="scss" scoped>
.asahi-logo {
  height: 65px;
  @include media-breakpoint-down(lg) {
    height: 80px;
  }
}
</style>
